import React, { useEffect } from 'react'
import img1 from "../images/games-2.jpg";
import Carousel from './sub_components/Carousel';
import Slider from './sub_components/Slider';
import FAQ from './sub_components/FAQ';
import video from "../videos/home-banner-video.mp4";
import playbutton from "../images/playbutton.png";
// import Atropos library
import Atropos from 'atropos/react';
import 'atropos/css'

function Home(props) {


    useEffect(() => {
        props.setProgress(100);
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div className="">
                <div className="banner bg-[#fffd63]">
                    <div className="text-center px-[10px] py-[120px] lg:px-[100px] sm:py-[150px]">
                        <h1 className='text-[40px] sm:text-[60px] text-[#0a0b1e] font-black leading-none'>
                            Run more engaging sessions.
                        </h1>
                        <h1 className='text-[40px] sm:text-[60px] text-[#0a0b1e] font-black mt-1 lg:-mt-3 leading-none sm:leading-tight'>
                            Get better outcomes.
                        </h1>

                        <h3 className='text-[18px] sm:text-[20px] mt-5 lg:w-[900px] lg:mx-auto'>
                            Butter’s agenda planner, delightful interactions, and integrated collaboration tools let you run super-engaging workshops, trainings, and meetings—without juggling a million tools.
                        </h3>
                        <br />
                        <div className='grid sm:flex gap-5 justify-center mt-2'>
                            <button className='bg-black rounded-[16px] text-white py-3 px-5 text-lg font-medium black-shadow'>Try SILE for free</button>
                            <button className='bg-white rounded-[16px] text-black py-3 px-5 text-lg font-medium black-shadow border-2 border-black'>Book a demo</button>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>

                <div className="video -translate-y-[50px] sm:-translate-y-[100px] lg:px-[50px] relative">
                    <video className='rounded-2xl shadow-sm shadow-gray-500 m-auto' src={video} autoPlay muted loop ></video>

                    <div className='hidden md:absolute top-0 left-0 w-[100%] h-[100%] md:flex items-center justify-center'>
                        <Atropos>
                            <div className="bg-white py-6 px-14 rounded-[50px] flex items-center justify-center gap-3 duration-200 " speed={0.2} id="play-button">
                                <img src={playbutton} className="max-w-[80px]" alt="img" /> <span className='text-[34px] font-bold'>Take 2 min. tour</span>
                            </div>
                        </Atropos>
                    </div>
                </div>

                <br />
                <div className="our_customers">
                    <h3 className='font-bold text-xl sm:text-2xl md:text-3xl text-center px-5 sm:px-10 my-10'>
                        More than 14 million people across 200,000 companies choose SILE
                    </h3>
                    <Slider />
                </div>

                <div className='mt-[120px]'>
                    <div className='px-5 sm:px-10 text-center'>
                        <h1 className='font-bold text-2xl sm:text-3xl md:text-4xl'>What We Offer</h1>
                        <h3 className='text-lg sm:text-2lg md:text-3lg mt-3'>
                            We offer wide range of services that can help your business to grow !
                        </h3>
                    </div>

                    <div className="what_we_offer mt-16 px-5 sm:px-10">

                        <div className="flex flex-wrap sm:px-10 md:flex-nowrap md:space-x-16 mb-12 lg:mb-0 items-center">
                            <div className="card bg-[#2B1C50] py-5 px-5 sm:px-16 sm:py-16 rounded-[35px] lg:rounded-[40px] text-center w-[100%] md:w-[55%]">
                                <img src={img1} className="rounded-3xl max-h-[300px] sm:max-h-[500px] md:max-h-[800px] m-auto" alt="" />
                            </div>
                            <div className='flex md:space-x-4 w-[100%] md:w-[45%] justify-center  mt-3 md:mt-0'>
                                <div className='pt-3 text-3xl hidden lg:block text-violet-500'>
                                    <i className="bi bi-bookmark-check"></i>
                                </div>
                                <div className="sm:max-w-[500px]">
                                    <h1 className='font-semibold text-xl sm:text-2xl md:text-[35px] md:leading-10'>Choose a game by purpose</h1>
                                    <h3 className='text-2sm sm:text-lg md:text-xl mt-5 text-slate-500 font-medium'>
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam in saepe doloremque, expedita ipsum, cupiditate commodi amet rem nam nihil dolores delectus culpa ipsam porro quasi aliquid vero accusamus sit.
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-wrap sm:px-10 md:flex-nowrap md:space-x-16 mb-12 lg:mb-0 items-center lg:translate-y-[-40px]">
                            <div className='flex md:space-x-4 w-[100%] md:w-[45%] justify-center mt-3 md:mt-0 order-2 md:order-1'>
                                <div className='pt-3 text-3xl hidden lg:block text-violet-500'>
                                    <i className="bi bi-bookmark-check"></i>
                                </div>
                                <div className="sm:max-w-[500px]">
                                    <h1 className='font-semibold text-xl sm:text-2xl md:text-[35px] md:leading-10'>Run the session yourself or hire from community of 100+ facilitators</h1>
                                    <h3 className='text-2sm sm:text-lg md:text-xl mt-5 text-slate-500 font-medium'>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda, laborum quos error sapiente laboriosam ullam vel in molestiae rerum atque eius sequi et. Quo ipsa distinctio numquam alias eaque vel.
                                    </h3>
                                </div>
                            </div>
                            <div className="card bg-[#AFB0ED] py-5 px-5 sm:px-16 sm:py-16 rounded-[35px] lg:rounded-[40px] text-center w-[100%] md:w-[55%] order-1 md:order-2">
                                <img src={img1} className="rounded-3xl  max-h-[300px] sm:max-h-[500px] md:max-h-[800px] m-auto" alt="" />
                            </div>
                        </div>

                        <div className="flex flex-wrap sm:px-10 md:flex-nowrap md:space-x-16 mb-12 lg:mb-0 items-center lg:translate-y-[-80px]">
                            <div className="card bg-[#EEF0FF] py-5 px-5 sm:px-16 sm:py-16 rounded-[35px] lg:rounded-[40px] text-center w-[100%] md:w-[55%]">
                                <img src={img1} className="rounded-3xl  max-h-[300px] sm:max-h-[500px] md:max-h-[800px] m-auto" alt="" />
                            </div>
                            <div className='flex md:space-x-4 w-[100%] md:w-[45%] justify-center  mt-3 md:mt-0'>
                                <div className='pt-3 text-3xl hidden lg:block'>
                                    <i className="bi bi-bookmark-check text-violet-500"></i>
                                </div>
                                <div className="sm:max-w-[500px]">
                                    <h1 className='font-semibold text-xl sm:text-2xl md:text-[35px] md:leading-10'>Run fun training program</h1>
                                    <h3 className='text-2sm sm:text-lg md:text-xl mt-5 text-slate-500 font-medium'>
                                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Unde delectus, blanditiis voluptas assumenda quos magni doloremque quasi reprehenderit corporis aliquid, modi, nostrum numquam nam non veniam saepe in at aut?
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-wrap sm:px-10 md:flex-nowrap md:space-x-16 mb-12 lg:mb-0 items-center lg:translate-y-[-120px]">
                            <div className='flex md:space-x-4 w-[100%] md:w-[45%] justify-center mt-3 md:mt-0 order-2 md:order-1'>
                                <div className='pt-3 text-3xl hidden lg:block text-violet-500'>
                                    <i className="bi bi-bookmark-check"></i>
                                </div>
                                <div className="sm:max-w-[500px]">
                                    <h1 className='font-semibold text-xl sm:text-2xl md:text-[35px] md:leading-10'>Reflect with game analytic report</h1>
                                    <h3 className='text-2sm sm:text-lg md:text-xl mt-5 text-slate-500 font-medium'>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda, laborum quos error sapiente laboriosam ullam vel in molestiae rerum atque eius sequi et. Quo ipsa distinctio numquam alias eaque vel.
                                    </h3>
                                </div>
                            </div>
                            <div className="card bg-[#AFB0ED] py-5 px-5 sm:px-16 sm:py-16 rounded-[35px] lg:rounded-[40px] text-center w-[100%] md:w-[55%] order-1 md:order-2">
                                <img src={img1} className="rounded-3xl  max-h-[300px] sm:max-h-[500px] md:max-h-[800px] m-auto" alt="" />
                            </div>
                        </div>


                    </div>
                </div>


                {/* <div className='sm:px-10'>
                    <div className="banner bg-[#111019] mt-10 px-5 sm:px-10 py-16 text-center text-white flex justify-center items-center sm:rounded-[50px] flex-wrap">
                        <div className='mb-20'>
                            <h1 className='font-bold text-3xl sm:text-4xl md:text-5xl text-[#F1F0F3]'>
                                SILE on. Problem gone.
                            </h1>
                            <br />
                            <h3 className='text-lg sm:w-[80%] m-auto text-slate-300'>
                                We provide complete business management solution and develop custom games for employee traing. SILE gives wing to your business.
                            </h3>
                            <br />
                            <div className="text-center">
                                <button className='bg-[#565ADD] px-5 py-3 rounded-3xl text-white text-sm font-medium'> <i className="bi bi-box-arrow-up-right"></i> Learn More</button>
                            </div>
                        </div>
                        <div className=''>
                            <div className="rounded-r-2xl ">
                                <img src={img3} className="max-h-[300px] m-auto" alt="" />
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>




            <div className="mt-[80px]">
                <Carousel />
            </div>

            <FAQ />
        </>
    )
}

export default Home